export const hotSaleList = {
  clickTab: 'n.4724.6397.0',
  gotoInfo: 'n.4724.262.0',
  addCart: 'n.4724.10.0',
  clickFloatCart: 'n.4724.8970.0',
  clickMoreList: 'n.4724.9854.0',
  goBack: 'n.4724.8969.0',
  goodsExpose: 'n.4724.7711.0',
  gotoShop: 'n.4724.1434.0'
}
